<template>
    <v-dialog v-model="shows" max-width="480">
        <template #activator="{ attrs, on }">
            <slot name="default" v-bind="{ attrs, on }" />
        </template>
        <v-card class="v-card--dialog">
            <div class="v-card--dialog__head">
                <h3 class="tit tit--xs">교환권 번호 목록</h3>
                <v-btn fab color="transparent" @click="exit" class="v-card--dialog__close"><v-icon>mdi-close</v-icon></v-btn>
            </div>
            <div class="v-card--dialog__body page-text text-center">
                <v-data-table
                    v-bind="{
                        items,
                        headers,
                        itemsPerPage: -1,
                        itemClass: (item) => (item.fail ? 'error--text' : ''),
                    }"
                    hide-default-footer
                    disable-pagination
                    disable-sort
                    class="exchange-bulk-item-prev-table"
                >
                    <template v-for="(header, index) in headers.filter((header) => header.hasOwnProperty('formatter'))" #[`item.${header.value}`]="{ value, item }"> <span :key="index" v-html="header.formatter.bind(item)(value, item)" /> </template>
                </v-data-table>
            </div>
        </v-card>
    </v-dialog>
</template>

<script>
import { initDataTableHeaders, initUserExchangeBulk } from "@/assets/lib";

export default {
    props: {
        /** @type {import('vue').PropType<import('@/assets/lib').UserExchangeBulk>} */
        value: { type: Object, default: initUserExchangeBulk },
    },
    data: () => ({
        shows: false,
    }),
    computed: {
        items() {
            return this.value.exchanges;
        },
        headers() {
            return initDataTableHeaders([
                {
                    text: "교환권 번호",
                    value: "prev",
                    align: "center",
                },
                {
                    text: "금액",
                    value: "amount",
                    formatterType: "number",
                    suffix: "원",
                    align: "end",
                    width: 110,
                },
                {
                    text: "상태",
                    value: "type",
                    align: "center",
                    width: 100,
                },
            ]);
        },
    },
    methods: {
        exit() {
            this.shows = false;
        },
    },
};
</script>

<style lang="scss" scoped>
.exchange-bulk-item-prev-table {
    &,
    ::v-deep *,
    ::v-deep td {
        font-size: 14px !important;
        line-height: 1.25 !important;
    }

    ::v-deep tbody > tr.error--text > td {
        color: inherit !important;
    }
}
</style>
